/**
 * Visibility Utilities
 *
 * Show/hide UI sections and manage application state
 * @module portal/modules/ui/visibility
 */

import { els } from './elements';

/**
 * Hide the initial loading indicator and show the page container.
 * Called once auth state is determined.
 */
function revealPage(): void {
  const loadingEl = document.getElementById('page-loading');
  const pageContainer = document.getElementById('page-container');
  if (loadingEl) loadingEl.hidden = true;
  if (pageContainer) pageContainer.hidden = false;
}

/**
 * Show authentication card, hide main app
 */
export const showAuth = (): void => {
  revealPage();
  if (els.authCard) els.authCard.hidden = false;
  if (els.app) els.app.hidden = true;
};

/**
 * Show main app, hide authentication card.
 * If on the landing page (/), redirect to /portal.
 */
export const showApp = (): void => {
  // Redirect authenticated users from landing page to /portal
  const currentPath = window.location.pathname;
  if (currentPath === '/' || currentPath === '/index.html') {
    window.location.replace('/portal');
    return;
  }

  revealPage();
  if (els.authCard) els.authCard.hidden = true;
  if (els.app) els.app.hidden = false;
};

/**
 * Open mobile menu
 */
export function openMobileMenu(): void {
  const bodyEl = document.body;
  if (els.mobileMenu) {
    els.mobileMenu.classList.add('active');
  }
  if (els.mobileMenuBackdrop) {
    els.mobileMenuBackdrop.classList.add('active');
  }
  if (els.hamburgerMenuBtn) {
    els.hamburgerMenuBtn.setAttribute('aria-expanded', 'true');
  }
  bodyEl.classList.add('modal-open');
}

/**
 * Close mobile menu
 */
export function closeMobileMenu(): void {
  const bodyEl = document.body;
  if (els.mobileMenu) {
    els.mobileMenu.classList.remove('active');
  }
  if (els.mobileMenuBackdrop) {
    els.mobileMenuBackdrop.classList.remove('active');
  }
  if (els.hamburgerMenuBtn) {
    els.hamburgerMenuBtn.setAttribute('aria-expanded', 'false');
  }
  bodyEl.classList.remove('modal-open');
}
